<div class="shortcut-button primary-background">
  <div class="s-icon">
    <i class="material-icons colored-text">
      {{ icon }}
    </i>
    <div class="border-notif primary-background">
      <span class="notification inverse-color primary-background colored-text" *ngIf="nbNotif >= 0">{{ nbNotif }}</span>
    </div>
  </div>
  <div class="s-text">
    <h4 class="colored-text">{{ title }}</h4>
  </div>
</div>
